import store from "@/store"
import router from "@/router"

const logout = () => {
    store.commit("setAuth",false)
    localStorage.setItem("isAuth", JSON.stringify(false))
    localStorage.setItem("user", JSON.stringify(null))
    localStorage.setItem("token", JSON.stringify(null))
    router.push("login")
}

export default logout